export const offerLang = {
    bronze: {
        'en': 'BRONZE',
        'fr': 'BRONZE',
        'de': 'BRONZE',
        'ko': '브론즈',
        'ch': 'BRONZE',
        'ru': 'Бронзовый',
        'it': 'BRONZO',
        'jap': 'ブロンズ',
        'port': 'BRONZE',
        'turk': 'BRONZ',
        'viet': 'ĐỒNG',
        'spa': 'BRONZE',
        'arab': 'برونز'
    },
    silver: {
        'en': 'SILVER',
        'fr': 'ARGENT',
        'de': 'SILBER',
        'ko': '실버',
        'ch': 'SILVER',
        'ru': 'Серебрянный',
        'it': 'ARGENTO',
        'jap': 'シルバー',
        'port': 'PRATA',
        'turk': 'GÜMÜŞ',
        'viet': 'BẠC',
        'spa': 'SILVER',
        'arab': 'فضة'
    },
    gold: {
        'en': 'GOLD',
        'fr': 'OR',
        'de': 'GOLD',
        'ko': '골드',
        'ch': 'GOLD',
        'ru': 'Золотой',
        'it': 'ORO',
        'jap': 'ゴールド',
        'port': 'OURO',
        'turk': 'ALTIN',
        'viet': 'VÀNG',
        'spa': 'GOLD',
        'arab': 'ذهب'
    },
    enter_amount: {
        'en': 'Enter amount',
        'fr': 'Saisissez le montant',
        'de': 'Anzahl eingeben',
        'ko': '금액 입력',
        'ch': '输入金额',
        'ru': 'Введите кол-во',
        'it': 'Inserisci importo',
        'jap': '金額を入力',
        'port': 'Insira o valor',
        'turk': 'Miktar girin',
        'viet': 'Nhập số lượng',
        'spa': 'Introducir importe',
        'arab': 'أدخل المبلغ'
    },
    minimum2500: {
        'en': 'Minimum 250 USD',
        'fr': 'Minimum 2 50 USD',
        'de': 'Mindestens 2.50 USD',
        'ko': '최소 2,50달러',
        'ch': '最低 250 美元',
        'ru': 'Минимум 250 USD',
        'it': 'Minimo 250 USD',
        'jap': '最低2,50USD',
        'port': 'Mínimo 250 dólares',
        'turk': 'Minimum 250 USD',
        'viet': 'Tối đa 2.50 USD',
        'spa': 'Mínimo 250 USD',
        'arab': 'الحد الأدنى 250 دولار أمريكي'
    },
    minimum5000: {
        'en': 'Minimum 5000 USD',
        'fr': 'Minimum 5 000 USD',
        'de': 'Mindestens 5.000 USD',
        'ko': '최소 5,000달러',
        'ch': '最低 5000 美元',
        'ru': 'Минимум 5000 USD',
        'it': 'Minimo 5000 USD',
        'jap': '最低5,000USD',
        'port': 'Mínimo 5000 dólares',
        'turk': 'Minimum 5000 USD',
        'viet': 'Tối đa 5.000 USD',
        'spa': 'Mínimo 5000 USD',
        'arab': 'الحد الأدنى 5000 دولار أمريكي'
    },
    minimum10000: {
        'en': 'Minimum 10000 USD',
        'fr': 'Minimum 10 000 USD',
        'de': 'Mindestens 10.000 USD',
        'ko': '최소 10,000달러',
        'ch': '最低 10000 美元',
        'ru': 'Минимум 10000 USD',
        'it': 'Minimo 10000 USD',
        'jap': '最低10,000USD',
        'port': 'Mínimo 10000 dólares',
        'turk': 'Minimum 10000 USD',
        'viet': 'Tối đa 10.000 USD',
        'spa': 'Mínimo 10000 USD',
        'arab': 'الحد الأدنى 10000 دولار أمريكي'
    },
    payment_coin: {
        'en': 'Payment Coin:',
        'fr': 'Devise de paiement:',
        'de': 'Coin für die Zahlung:',
        'ko': '결제 코인:',
        'ch': '支付币：',
        'ru': 'Платежная монета',
        'it': 'Moneta di Pagamento:',
        'jap': '決済コイン：',
        'port': 'Moeda de pagamento:',
        'turk': 'Ödeme Coini:',
        'viet': 'Coin thanh toán:',
        'spa': 'Moneda de pago:',
        'arab': 'عملة الدفع:'
    },
    bonus1: {
        'en': 'Bonus 1%',
        'fr': 'Bonus de 1%',
        'de': 'Bonus 1%',
        'ko': '보너스 1%',
        'ch': '奖金 1%',
        'ru': 'Бонус 1%',
        'it': 'Bonus 1%',
        'jap': 'ボーナス1%',
        'port': 'Bônus de 1%',
        'turk': '%1 Bonus',
        'viet': 'Thưởng 1%',
        'spa': 'Bonificación del 1%',
        'arab': 'المكافأة1٪'
    },
    bonus3: {
        'en': 'Bonus 3%',
        'fr': 'Bonus de 3%',
        'de': 'Bonus 3%',
        'ko': '보너스 3%',
        'ch': '奖金 3%',
        'ru': 'Бонус 3%',
        'it': 'Bonus 3%',
        'jap': 'ボーナス3%',
        'port': 'Bônus de 3%',
        'turk': '%3 Bonus',
        'viet': 'Thưởng 3%',
        'spa': 'Bonificación del 3%',
        'arab': 'المكافأة3٪'
    },
    bonus5: {
        'en': 'Bonus 5%',
        'fr': 'Bonus de 5%',
        'de': 'Bonus 5%',
        'ko': '보너스 5%',
        'ch': '奖金 5%',
        'ru': 'Бонус 5%',
        'it': 'Bonus 5%',
        'jap': 'ボーナス5%',
        'port': 'Bônus de 5%',
        'turk': '%5 Bonus',
        'viet': 'Thưởng 5%',
        'spa': 'Bonificación del 5%',
        'arab': 'المكافأة5٪'
    },
    total_bonus: {
        'en': 'Total with bonus: ',
        'fr': 'Total avec le bonus:',
        'de': 'Gesamt mit Bonus:',
        'ko': '보너스 포함 합계:',
        'ch': '总奖金：',
        'ru': 'Всего с бонусом:',
        'it': 'Totale con bonus:',
        'jap': 'ボーナス込みの合計：',
        'port': 'Total com bônus:',
        'turk': 'Bonus ile birlikte toplam:',
        'viet': 'Tổng tiền thưởng:',
        'spa': 'Total con bonificación:',
        'arab': 'الإجمالي مع المكافأة:'
    },
    wait: {
        'en': 'PLEASE WAIT',
        'fr': 'PATIENTER',
        'de': 'BITTE WARTEN',
        'ko': '기다려 주십시오',
        'ch': '请稍等',
        'ru': 'Подождите',
        'it': 'PER FAVORE ASPETTA',
        'jap': '待ってください',
        'port': 'AGUAR',
        'turk': 'LÜTFEN BEKLEYİN',
        'viet': 'XIN VUI LÒNG CHỜ ĐỢI',
        'spa': 'Espera un momento',
        'arab': 'يرجى الانتظار'
    },
    buy: {
        'en': 'BUY',
        'fr': 'ACHETER',
        'de': 'KAUFEN',
        'ko': '구매',
        'ch': '购买',
        'ru': 'Купить',
        'it': 'ACQUISTARE',
        'jap': '購入',
        'port': 'COMPRAR',
        'turk': 'ALMAK',
        'viet': 'MUA',
        'spa': 'COMPRAR',
        'arab': 'شراء'
    },
    from: {
        'en': 'From',
        'fr': 'De',
        'de': 'Von',
        'ko': '에서',
        'ch': '从',
        'ru': 'От',
        'it': 'Da',
        'jap': 'から',
        'port': 'De',
        'turk': '-den',
        'viet': 'Từ',
        'spa': 'De',
        'arab': 'من عند'
    },
    notsale: {
        'en': 'Please wait for the next sale',
        'fr': 'Veuillez attendre la prochaine vente',
        'de': 'Bitte warten Sie auf den nächsten Verkauf',
        'ko': '다음 세일을 기다려주세요',
        'ch': '请等待下一次销售',
        'ru': 'Пожалуйста дождитесь следующего этапа продажи',
        'it': 'Si prega di attendere per la prossima vendita',
        'jap': '次の販売をお待ちください',
        'port': 'Aguarde a próxima venda',
        'turk': 'Lütfen bir sonraki satışı bekleyin',
        'viet': 'Xin vui lòng chờ đợi cho tới bán',
        'spa': 'Por favor, espere la próxima venta',
        'arab': 'يرجى الانتظار للبيع المقبل'
    },
}